export default __webpack_public_path__ + "static/media/permisos.c0e012c3.png";